import React from "react";

import IMedicalFormElementProps from "../Types/IMedicalFormElement";
import BaseMedicalQuestion, { IMedicalQuestionConfig } from "./BaseMedicalQuestion";

/**
 * An implementation of {@link BaseMedicalQuestion} that does not render any form element, and should be used for
 * dialogue only.
 */
const NoElementFormItem: React.FC<Omit<IMedicalQuestionConfig, "FormElement"> & IMedicalFormElementProps> = props => (
  <BaseMedicalQuestion {...props} FormElement={null} />
);

export default NoElementFormItem;
